import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';

export function getName() {
  return 'SharedBudgetSummaryGrid';
}

export function getColumnsMetadata() {
  return _.defaults({
    Status: [],
    BudgetName: 'Name',
    BudgetStatus: 'Status',
    CampaignCount: 'AssociationCount',
    TotalEffectiveCost: 'PerformanceMetrics/Spend',
  }, _.omit(PerformanceMetricsColumns, 'Spend'));
}

export function getRoute() {
  return 'customer/:customer_id/account/:account_id/library/sharedbudget';
}
